import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default';
try { AsyncStorage.getItem('userToken').then(t=>{if(t)_profUserId=t.slice(0,16);}).catch(()=>{}); } catch {}

import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  View, Text, StyleSheet, TouchableOpacity, ScrollView, SafeAreaView, StatusBar,
  Image, TextInput, FlatList, RefreshControl, ActivityIndicator, Linking, Alert,
  Modal, Animated, Share, Dimensions, KeyboardAvoidingView, Platform,
} from 'react-native';
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

let LinearGradient;
try { LinearGradient = require('expo-linear-gradient').LinearGradient; } catch {
  LinearGradient = ({colors,style,children,...p}) => <View style={[style,{backgroundColor:colors?.[0]||'#0e4e96'}]} {...p}>{children}</View>;
}

const { width } = Dimensions.get('window');
const API_BASE = 'https://api.jobeng.ai';
const API_KEY  = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// ─── Shared keys ──────────────────────────────────────────────────────────────
const SHARED = {
  PORTAL_APPS : 'intern_portal_applications',
  PROGRAMS    : 'intern_programs',
  SAVED       : 'studentData',
};
const mkId = () => `app_${Date.now()}_${Math.random().toString(36).slice(2,6)}`;
const loadStudentProfile = async () => { try { const r=await AsyncStorage.getItem(SHARED.SAVED); if(r){const d=JSON.parse(r);return d.profile||{};} } catch {} return {}; };
const loadStudentApps = async () => { try { const r=await AsyncStorage.getItem(SHARED.PORTAL_APPS); if(r) return JSON.parse(r)||[]; } catch {} return []; };
const submitToPortal = async (newApp) => {
  try {
    const existing=await loadStudentApps(); const merged=[newApp,...existing.filter(a=>a.id!==newApp.id)];
    await AsyncStorage.setItem(SHARED.PORTAL_APPS,JSON.stringify(merged));
    const sdRaw=await AsyncStorage.getItem(SHARED.SAVED); const sd=sdRaw?JSON.parse(sdRaw):{};
    sd.applications=merged; await AsyncStorage.setItem(SHARED.SAVED,JSON.stringify(sd)); return true;
  } catch { return false; }
};
const toggleSaveToPortal = async (id,saving) => {
  try {
    const sdRaw=await AsyncStorage.getItem(SHARED.SAVED); const sd=sdRaw?JSON.parse(sdRaw):{};
    const saved=sd.savedPrograms||[];
    sd.savedPrograms=saving?[...new Set([...saved,id])]:saved.filter(x=>x!==id);
    await AsyncStorage.setItem(SHARED.SAVED,JSON.stringify(sd));
  } catch {}
};
const fmtDate = d => { try { return new Date(d).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}); } catch { return d||''; } };
const daysLeft = d => Math.ceil((new Date(d)-new Date())/(1000*60*60*24));

const STATUS_COLORS = {
  Submitted:'#8B5CF6','Under Review':'#F59E0B','Interview Scheduled':'#3B82F6',
  Accepted:'#10B981',Rejected:'#EF4444','More Info Requested':'#0891B2',
  Shortlisted:'#059669',Withdrawn:'#94A3B8',
};

const MOCK_INTERNSHIPS = [
  { id:'1', title:'Software Engineering Intern', company:'Google UK', location:'London', duration:'3 months', compensation:'£2,500/month', deadline:'2025-08-30', description:'Join our engineering team to develop innovative solutions for Google products used by millions worldwide.', requirements:['CS or related degree','Python, Java or C++','Strong problem-solving skills','Excellent communication'], logo:'https://logo.clearbit.com/google.com', field:'Technology', isRemote:false, isPaid:true, applicationLink:'https://careers.google.com/internships/', postedDate:'2025-05-15', matchScore:92, rating:4.9, reviews:324 },
  { id:'2', title:'Mechanical Engineering Intern', company:'Rolls-Royce', location:'Derby', duration:'6 months', compensation:'£2,000/month', deadline:'2025-07-15', description:'Work alongside our engineering teams on cutting-edge aerospace technologies.', requirements:['Mechanical Engineering degree','Fluid dynamics knowledge','CAD software proficiency'], logo:'https://logo.clearbit.com/rolls-royce.com', field:'Engineering', isRemote:false, isPaid:true, applicationLink:'https://careers.rolls-royce.com', postedDate:'2025-05-10', matchScore:85, rating:4.7, reviews:189 },
  { id:'3', title:'Data Science Intern', company:'Meta', location:'Remote', duration:'3 months', compensation:'£2,300/month', deadline:'2025-07-25', description:'Apply machine learning and statistical analysis to extract insights from large datasets.', requirements:['Data Science/Statistics degree','Python/R','ML algorithms'], logo:'https://logo.clearbit.com/meta.com', field:'Data Science', isRemote:true, isPaid:true, applicationLink:'https://www.metacareers.com/internships/', postedDate:'2025-05-20', matchScore:88, rating:4.8, reviews:256 },
  { id:'4', title:'UX Design Intern', company:'Apple', location:'London', duration:'4 months', compensation:'£2,400/month', deadline:'2025-07-01', description:'Create intuitive and beautiful user experiences for Apple products and services.', requirements:["Design/HCI degree","Strong portfolio","Figma/Sketch proficiency"], logo:'https://logo.clearbit.com/apple.com', field:'Design', isRemote:false, isPaid:true, applicationLink:'https://www.apple.com/careers/students/', postedDate:'2025-05-12', matchScore:78, rating:4.9, reviews:412 },
  { id:'5', title:'Finance Intern', company:'HSBC', location:'London', duration:'6 months', compensation:'£2,100/month', deadline:'2025-07-10', description:'Work with finance teams on financial analysis, reporting, and strategic planning.', requirements:["Finance/Accounting degree","Excel proficiency","Analytical skills"], logo:'https://logo.clearbit.com/hsbc.com', field:'Finance', isRemote:false, isPaid:true, applicationLink:'https://www.hsbc.com/careers', postedDate:'2025-05-18', matchScore:72, rating:4.6, reviews:203 },
  { id:'6', title:'Research Intern - AI', company:'DeepMind', location:'London', duration:'4 months', compensation:'£2,600/month', deadline:'2025-06-25', description:'Contribute to cutting-edge AI and machine learning research alongside world-class researchers.', requirements:["PhD/MSc in CS or AI","Deep learning expertise","Python/TensorFlow/PyTorch"], logo:'https://logo.clearbit.com/deepmind.com', field:'Research', isRemote:false, isPaid:true, applicationLink:'https://deepmind.com/careers/internships', postedDate:'2025-05-22', matchScore:95, rating:4.9, reviews:98 },
  { id:'7', title:'Marketing Intern', company:'Unilever', location:'London', duration:'3 months', compensation:'£1,800/month', deadline:'2025-08-20', description:'Gain hands-on experience in brand management and digital marketing with a global leader.', requirements:["Marketing/Business degree","Strong communication","Digital marketing knowledge"], logo:'https://logo.clearbit.com/unilever.com', field:'Marketing', isRemote:false, isPaid:true, applicationLink:'https://careers.unilever.com', postedDate:'2025-05-05', matchScore:65, rating:4.5, reviews:167 },
  { id:'8', title:'Civil Engineering Intern', company:'Arup', location:'Manchester', duration:'6 months', compensation:'£1,900/month', deadline:'2025-07-05', description:'Work on sustainable infrastructure projects and gain practical experience in civil engineering design.', requirements:["Civil Engineering degree","Structural analysis knowledge","AutoCAD proficiency"], logo:'https://logo.clearbit.com/arup.com', field:'Engineering', isRemote:false, isPaid:true, applicationLink:'https://www.arup.com/careers', postedDate:'2025-05-08', matchScore:80, rating:4.7, reviews:134 },
];

const FILTER_OPTIONS = ['All','Technology','Engineering','Design','Marketing','Finance','Research','Data Science','Remote','Paid','Applied','Saved'];
const SORT_OPTIONS   = ['Best Match','Deadline','Posted Date','Compensation','Rating'];
const FIELD_COLORS   = {Technology:'#0e4e96',Engineering:'#D97706',Design:'#7C3AED',Marketing:'#DB2777',Finance:'#059669',Research:'#B45309','Data Science':'#0891B2'};

// ─────────────────────────────────────────────────────────────────────────────
export default function InternshipApplicationScreen() {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  const navigation = useNavigation();

  // ── Tabs ──────────────────────────────────────────────────────────────────
  const [activeMainTab, setActiveMainTab] = useState('browse'); // browse | myApps

  // ── Data ──────────────────────────────────────────────────────────────────
  const [internships,         setInternships]         = useState([]);
  const [filteredInternships, setFilteredInternships] = useState([]);
  const [publishedPrograms,   setPublishedPrograms]   = useState([]);
  const [isLoading,           setIsLoading]           = useState(true);
  const [refreshing,          setRefreshing]          = useState(false);
  const [error,               setError]               = useState(null);

  // ── Portal sync ───────────────────────────────────────────────────────────
  const [savedIds,       setSavedIds]       = useState(new Set());
  const [appliedIds,     setAppliedIds]     = useState(new Set());
  const [myApplications, setMyApplications] = useState([]);
  const [studentProfile, setStudentProfile] = useState({});
  const [syncingId,      setSyncingId]      = useState(null);

  // ── Browse UI ─────────────────────────────────────────────────────────────
  const [searchQuery,    setSearchQuery]    = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedSort,   setSelectedSort]   = useState('Best Match');
  const [viewMode,       setViewMode]       = useState('list');
  const [showSortModal,  setShowSortModal]  = useState(false);
  const [compareList,    setCompareList]    = useState([]);
  const [showCompare,    setShowCompare]    = useState(false);

  // ── Apply form ────────────────────────────────────────────────────────────
  const [showApplyModal,  setShowApplyModal]  = useState(false);
  const [applyTarget,     setApplyTarget]     = useState(null);
  const [applying,        setApplying]        = useState(false);
  const [appForm, setAppForm] = useState({ coverLetter:'', whyInterested:'', relevantExperience:'', availability:'', additionalInfo:'' });

  // ── App detail modal ──────────────────────────────────────────────────────
  const [showAppDetail,  setShowAppDetail]  = useState(false);
  const [selectedMyApp,  setSelectedMyApp]  = useState(null);

  // ── My Apps filter ────────────────────────────────────────────────────────
  const [appStatusFilter, setAppStatusFilter] = useState('All');

  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    loadAll();
    Animated.timing(fadeAnim,{toValue:1,duration:600,useNativeDriver:true}).start();
  }, []);

  useFocusEffect(useCallback(() => { syncPortalData(); }, []));

  const syncPortalData = async () => {
    const profile = await loadStudentProfile();
    setStudentProfile(profile);
    const apps = await loadStudentApps();
    setAppliedIds(new Set(apps.map(a=>a.programId)));
    setMyApplications(apps.sort((a,b)=>new Date(b.submittedAt||b.appliedDate)-new Date(a.submittedAt||a.appliedDate)));
    const sdRaw = await AsyncStorage.getItem(SHARED.SAVED);
    if (sdRaw) { const sd=JSON.parse(sdRaw); setSavedIds(new Set(sd.savedPrograms||[])); }
    try {
      const progRaw = await AsyncStorage.getItem(SHARED.PROGRAMS);
      if (progRaw) { const pub=JSON.parse(progRaw).filter(p=>p.published); setPublishedPrograms(pub); }
    } catch {}
  };

  const loadAll = async () => {
    setIsLoading(true); setError(null);
    try {
      const r = await apiFetch('/api/data/jobs?job_type=internship&sort=created_at&order=desc&limit=30');
      if (!r.error && (Array.isArray(r.data)||Array.isArray(r))) {
        const jobs = (r.data||r).filter(j=>j.title).map(j=>({
          id:j.id||mkId(), title:j.title, company:j.company||'Company',
          location:j.location||'UK', duration:j.duration||'3 months',
          compensation:j.salary?.budget||'Competitive',
          deadline:j.deadline||new Date(Date.now()+30*86400000).toISOString().split('T')[0],
          description:j.description||'', requirements:j.requirements||[],
          logo:`https://logo.clearbit.com/${(j.company||'company').toLowerCase().replace(/\s/g,'')}.com`,
          field:j.field||'Technology', isRemote:!!j.isRemote, isPaid:true,
          applicationLink:j.applicationLink||null,
          postedDate:j.created_at?.split('T')[0]||new Date().toISOString().split('T')[0],
          matchScore:Math.floor(Math.random()*30)+65, rating:4.5, reviews:50,
        }));
        if (jobs.length>0) { setInternships(jobs); await syncPortalData(); return; }
      }
    } catch {}
    setInternships(MOCK_INTERNSHIPS);
    await syncPortalData();
    setIsLoading(false);
  };

  const onRefresh = async () => { setRefreshing(true); await loadAll(); setRefreshing(false); };

  // ── Filtering ─────────────────────────────────────────────────────────────
  useEffect(() => {
    const existingIds = new Set(internships.map(x=>x.id));
    const extra = publishedPrograms.filter(p=>!existingIds.has(p.id)).map(p=>({
      id:p.id, title:p.title, company:p.companyName||'Company', location:p.location||'UK',
      duration:(p.duration||'12')+' weeks', compensation:p.stipend_range||p.stipend||'Competitive',
      deadline:p.start_date||new Date(Date.now()+30*86400000).toISOString().split('T')[0],
      description:p.description||'',
      requirements:(p.requirements||'').split(',').map(s=>s.trim()).filter(Boolean),
      logo:`https://logo.clearbit.com/${(p.companyName||'company').toLowerCase().replace(/\s/g,'')}.com`,
      field:p.department||'Technology', isRemote:p.type==='Virtual', isPaid:true,
      applicationLink:null, postedDate:p.created_at?.split('T')[0]||new Date().toISOString().split('T')[0],
      matchScore:80, rating:4.8, reviews:0, fromPortal:true,
    }));
    const all = [...internships, ...extra];
    let f = [...all];
    const q = searchQuery.toLowerCase();
    if (q) f=f.filter(i=>[i.title,i.company,i.location,i.field].some(s=>(s||'').toLowerCase().includes(q)));
    if      (selectedFilter==='Remote')  f=f.filter(i=>i.isRemote);
    else if (selectedFilter==='Paid')    f=f.filter(i=>i.isPaid);
    else if (selectedFilter==='Applied') f=f.filter(i=>appliedIds.has(i.id));
    else if (selectedFilter==='Saved')   f=f.filter(i=>savedIds.has(i.id));
    else if (selectedFilter!=='All')     f=f.filter(i=>i.field===selectedFilter);
    f.sort((a,b) => {
      if (selectedSort==='Best Match')   return (b.matchScore||0)-(a.matchScore||0);
      if (selectedSort==='Deadline')     return new Date(a.deadline)-new Date(b.deadline);
      if (selectedSort==='Posted Date')  return new Date(b.postedDate)-new Date(a.postedDate);
      if (selectedSort==='Compensation') return parseInt((b.compensation||'').replace(/[^0-9]/g,''))-parseInt((a.compensation||'').replace(/[^0-9]/g,''));
      if (selectedSort==='Rating')       return (b.rating||0)-(a.rating||0);
      return 0;
    });
    setFilteredInternships(f);
    setIsLoading(false);
  }, [internships, publishedPrograms, searchQuery, selectedFilter, selectedSort, appliedIds, savedIds]);

  // ── Actions ───────────────────────────────────────────────────────────────
  const handleToggleSave = async (item) => {
    const nowSaved = !savedIds.has(item.id);
    setSavedIds(prev=>{ const n=new Set(prev); nowSaved?n.add(item.id):n.delete(item.id); return n; });
    await toggleSaveToPortal(item.id, nowSaved);
  };

  const openApply = (item) => {
    if (appliedIds.has(item.id)) { Alert.alert('Already Applied','Check My Applications for status updates.'); return; }
    setApplyTarget(item);
    setAppForm({coverLetter:'',whyInterested:'',relevantExperience:'',availability:'',additionalInfo:''});
    setShowApplyModal(true);
  };

  const submitApplication = async () => {
    if (!appForm.coverLetter.trim()||!appForm.availability.trim()) {
      Alert.alert('Required','Cover Letter and Availability are required.'); return;
    }
    const item = applyTarget;
    if (item.applicationLink) {
      Alert.alert('External Application',`Also open ${item.company}'s website?`,[
        {text:'Portal Only', onPress:()=>doSubmit(item)},
        {text:'Both',        onPress:()=>{Linking.openURL(item.applicationLink).catch(()=>{}); doSubmit(item);}},
        {text:'Cancel',style:'cancel'},
      ]); return;
    }
    await doSubmit(item);
  };

  const doSubmit = async (item) => {
    setApplying(true);
    const newApp = {
      id:mkId(), programId:item.id, programTitle:item.title, company:item.company,
      status:'Submitted', appliedDate:new Date().toISOString().split('T')[0],
      submittedAt:new Date().toISOString(), progress:10, nextStep:'Initial Review',
      feedback:'Application submitted successfully.', documents:['Resume'],
      source:'application_screen', ...appForm,
      studentName:studentProfile.name||'', studentEmail:studentProfile.email||'',
      studentPhone:studentProfile.phone||'', studentUniversity:studentProfile.university||'',
      studentMajor:studentProfile.major||'', studentGpa:studentProfile.gpa||'',
      studentSkills:studentProfile.skills||[],
    };
    const ok = await submitToPortal(newApp);
    setApplying(false);
    if (ok) {
      setAppliedIds(prev=>new Set([...prev,item.id]));
      setMyApplications(prev=>[newApp,...prev]);
      setShowApplyModal(false);
      Alert.alert('🎉 Applied!',`Application to ${item.title} submitted! Track it in My Applications.`);
      setActiveMainTab('myApps');
    } else { Alert.alert('Error','Could not submit. Please try again.'); }
  };

  const withdrawApp = (app) => {
    Alert.alert('Withdraw','Remove your application to '+app.programTitle+'?',[
      {text:'Cancel',style:'cancel'},
      {text:'Withdraw',style:'destructive',onPress:async()=>{
        const updated = myApplications.map(a=>a.id===app.id?{...a,status:'Withdrawn',progress:0}:a);
        setMyApplications(updated);
        await AsyncStorage.setItem(SHARED.PORTAL_APPS, JSON.stringify(updated));
        const sdRaw=await AsyncStorage.getItem(SHARED.SAVED); const sd=sdRaw?JSON.parse(sdRaw):{};
        sd.applications=updated; await AsyncStorage.setItem(SHARED.SAVED,JSON.stringify(sd));
        setShowAppDetail(false);
      }},
    ]);
  };

  const toggleCompare = (item) => {
    setCompareList(prev=>{
      if (prev.find(x=>x.id===item.id)) return prev.filter(x=>x.id!==item.id);
      if (prev.length>=3) { Alert.alert('Limit','Compare up to 3 internships.'); return prev; }
      return [...prev,item];
    });
  };

  const handleShare = async (item) => {
    try { await Share.share({title:item.title,message:`${item.title} at ${item.company}\n${item.compensation} · ${item.location}\nDeadline: ${fmtDate(item.deadline)}`}); } catch {}
  };

  // ── Stats ──────────────────────────────────────────────────────────────────
  const stats = {
    total:    filteredInternships.length,
    applied:  appliedIds.size,
    saved:    savedIds.size,
    pending:  myApplications.filter(a=>['Submitted','Under Review','Shortlisted'].includes(a.status)).length,
    interview:myApplications.filter(a=>a.status==='Interview Scheduled').length,
    accepted: myApplications.filter(a=>a.status==='Accepted').length,
    urgent:   filteredInternships.filter(i=>{const d=daysLeft(i.deadline);return d>=0&&d<=7;}).length,
  };

  const scColor = s => STATUS_COLORS[s]||'#94A3B8';

  // ═══════════════════════════════════════════════════════════════════════════
  // BROWSE TAB — CARDS
  // ═══════════════════════════════════════════════════════════════════════════
  const renderCard = (item) => {
    const days=daysLeft(item.deadline), isPast=days<0, urgent=days>=0&&days<=7;
    const fc   = FIELD_COLORS[item.field]||'#0e4e96';
    const inCmp= compareList.some(x=>x.id===item.id);
    const saved= savedIds.has(item.id);
    const appl = appliedIds.has(item.id);
    return (
      <TouchableOpacity key={item.id} style={[st.card, urgent&&{borderLeftWidth:3,borderLeftColor:'#EF4444'}]}
        activeOpacity={0.93}
        onPress={()=>navigation.navigate('InternshipDetails',{internship:item})}>
        {item.matchScore>=90&&(
          <View style={st.hotBadge}><Text style={st.hotBadgeT}>🔥 Top Match</Text></View>
        )}
        {item.fromPortal&&(
          <View style={[st.hotBadge,{backgroundColor:'#D1FAE5',left:12,right:undefined}]}>
            <Text style={[st.hotBadgeT,{color:'#059669'}]}>✓ Verified</Text>
          </View>
        )}

        <View style={st.cardTop}>
          <Image source={{uri:item.logo}} style={st.logo} defaultSource={{uri:'https://via.placeholder.com/48/F1F5F9'}}/>
          <View style={{flex:1}}>
            <Text style={st.cardTitle} numberOfLines={1}>{item.title}</Text>
            <Text style={st.cardCo}>{item.company}</Text>
            <View style={st.metaRow}>
              <View style={st.metaItem}><Ionicons name="location-outline" size={12} color="#64748B"/><Text style={st.metaT}>{item.location}</Text></View>
              <View style={st.metaItem}><Ionicons name="time-outline" size={12} color="#64748B"/><Text style={st.metaT}>{item.duration}</Text></View>
              <View style={st.metaItem}><Ionicons name="cash-outline" size={12} color="#10B981"/><Text style={[st.metaT,{color:'#10B981',fontWeight:'600'}]}>{item.compensation}</Text></View>
            </View>
          </View>
          <View style={{gap:5}}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>handleToggleSave(item)}>
              <Ionicons name={saved?'bookmark':'bookmark-outline'} size={17} color={saved?'#667eea':'#94A3B8'}/>
            </TouchableOpacity>
            <TouchableOpacity style={st.iconBtn} onPress={()=>handleShare(item)}>
              <Ionicons name="share-social-outline" size={17} color="#94A3B8"/>
            </TouchableOpacity>
          </View>
        </View>

        <Text style={st.cardDesc} numberOfLines={2}>{item.description}</Text>

        <View style={st.tagsRow}>
          <View style={[st.tag,{backgroundColor:fc+'15',borderColor:fc+'30'}]}>
            <Text style={[st.tagT,{color:fc}]}>{item.field}</Text>
          </View>
          {item.isRemote&&<View style={[st.tag,{backgroundColor:'#ECFDF5',borderColor:'#6EE7B7'}]}><Text style={[st.tagT,{color:'#059669'}]}>Remote</Text></View>}
          {item.matchScore&&<View style={[st.tag,{backgroundColor:'#EEF2FF',borderColor:'#C4B5FD'}]}><Text style={[st.tagT,{color:'#667eea'}]}>{item.matchScore}% Match</Text></View>}
          <View style={[st.tag,{backgroundColor:urgent?'#FEF2F2':'#FFF7ED',borderColor:urgent?'#FCA5A5':'#FED7AA'}]}>
            <Text style={[st.tagT,{color:urgent?'#DC2626':'#D97706',fontWeight:'700'}]}>
              {isPast?'Closed':urgent?`${days}d left!`:fmtDate(item.deadline)}
            </Text>
          </View>
        </View>

        <View style={st.cardFoot}>
          <View style={{flexDirection:'row',alignItems:'center',gap:4}}>
            <Ionicons name="star" size={13} color="#F59E0B"/>
            <Text style={st.ratingT}>{item.rating}</Text>
            <Text style={{fontSize:11,color:'#94A3B8'}}>({item.reviews})</Text>
            <TouchableOpacity style={[st.cmpBtn,inCmp&&{backgroundColor:'#0e4e96'}]} onPress={()=>toggleCompare(item)}>
              <MaterialCommunityIcons name="compare" size={13} color={inCmp?'#FFF':'#667eea'}/>
            </TouchableOpacity>
          </View>
          <View style={{flexDirection:'row',gap:6}}>
            <TouchableOpacity style={st.detailBtn}
              onPress={()=>navigation.navigate('InternshipDetails',{internship:item})}>
              <Text style={st.detailBtnT}>Details</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[st.applyBtn,isPast&&{backgroundColor:'#E5E7EB'},appl&&{backgroundColor:'#D1FAE5'},urgent&&!isPast&&!appl&&{backgroundColor:'#EF4444'}]}
              disabled={isPast||syncingId===item.id} onPress={()=>openApply(item)}>
              {syncingId===item.id
                ? <ActivityIndicator size={13} color="#FFF"/>
                : <Text style={[st.applyBtnT,isPast&&{color:'#6B7280'},appl&&{color:'#059669'}]}>
                    {isPast?'Closed':appl?'Applied ✓':'Apply'}
                  </Text>
              }
            </TouchableOpacity>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  const renderGridCard = (item) => {
    const days=daysLeft(item.deadline), isPast=days<0, urgent=days>=0&&days<=7;
    const fc=FIELD_COLORS[item.field]||'#0e4e96', appl=appliedIds.has(item.id);
    return (
      <TouchableOpacity key={item.id} style={[st.gridCard,urgent&&{borderTopWidth:3,borderTopColor:'#EF4444'}]}
        onPress={()=>navigation.navigate('InternshipDetails',{internship:item})}>
        <Image source={{uri:item.logo}} style={st.gridLogo}/>
        <Text style={st.gridTitle} numberOfLines={2}>{item.title}</Text>
        <Text style={st.gridCo}>{item.company}</Text>
        <Text style={{fontSize:11,color:'#10B981',fontWeight:'600',marginTop:3}}>{item.compensation}</Text>
        <View style={{flexDirection:'row',gap:4,marginTop:6,flexWrap:'wrap'}}>
          <View style={[st.tag,{backgroundColor:fc+'15',borderColor:fc+'30'}]}><Text style={[st.tagT,{color:fc,fontSize:9}]}>{item.field}</Text></View>
          {item.isRemote&&<View style={[st.tag,{backgroundColor:'#ECFDF5',borderColor:'#6EE7B7'}]}><Text style={[st.tagT,{color:'#059669',fontSize:9}]}>Remote</Text></View>}
        </View>
        <View style={{flexDirection:'row',justifyContent:'space-between',marginTop:8,alignItems:'center'}}>
          <TouchableOpacity style={st.iconBtn} onPress={()=>handleToggleSave(item)}>
            <Ionicons name={savedIds.has(item.id)?'bookmark':'bookmark-outline'} size={15} color={savedIds.has(item.id)?'#667eea':'#94A3B8'}/>
          </TouchableOpacity>
          <TouchableOpacity style={[st.applyBtn,{paddingHorizontal:10,paddingVertical:6},isPast&&{backgroundColor:'#E5E7EB'},appl&&{backgroundColor:'#D1FAE5'}]}
            disabled={isPast} onPress={()=>openApply(item)}>
            <Text style={[st.applyBtnT,{fontSize:11},appl&&{color:'#059669'}]}>{isPast?'Closed':appl?'Applied ✓':'Apply'}</Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // MY APPLICATIONS TAB
  // ═══════════════════════════════════════════════════════════════════════════
  const filteredMyApps = appStatusFilter==='All'
    ? myApplications
    : myApplications.filter(a=>a.status===appStatusFilter);

  const renderMyAppCard = (app) => {
    const sc = scColor(app.status);
    return (
      <TouchableOpacity key={app.id} style={[st.appCard,{borderLeftColor:sc}]}
        onPress={()=>{setSelectedMyApp(app);setShowAppDetail(true);}}>
        <View style={{flexDirection:'row',alignItems:'flex-start'}}>
          <View style={{flex:1}}>
            <Text style={st.appTitle}>{app.programTitle}</Text>
            <Text style={st.appCo}>{app.company}</Text>
            <Text style={st.appDate}>Applied {fmtDate(app.appliedDate)}</Text>
          </View>
          <View style={[st.statusBadge,{backgroundColor:sc+'22'}]}>
            <Text style={[st.statusBadgeT,{color:sc}]}>{app.status}</Text>
          </View>
        </View>

        <View style={{marginTop:10,marginBottom:6}}>
          <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:5}}>
            <Text style={{fontSize:12,color:'#64748B',fontWeight:'600'}}>Progress</Text>
            <Text style={{fontSize:12,fontWeight:'700',color:'#374151'}}>{app.progress||10}%</Text>
          </View>
          <View style={{height:7,backgroundColor:'#E5E7EB',borderRadius:4,overflow:'hidden'}}>
            <View style={{height:7,borderRadius:4,backgroundColor:sc,width:`${app.progress||10}%`}}/>
          </View>
        </View>

        <Text style={{fontSize:12,color:'#374151'}}>→ {app.nextStep||'Initial Review'}</Text>

        {app.interviewDate&&(
          <View style={{flexDirection:'row',gap:6,backgroundColor:'#EFF6FF',borderRadius:8,padding:8,marginTop:6}}>
            <MaterialCommunityIcons name="calendar-clock" size={14} color="#3B82F6"/>
            <Text style={{fontSize:11,color:'#1D4ED8',fontWeight:'600'}}>
              Interview: {fmtDate(app.interviewDate)} {app.interviewTime||''} ({app.interviewType||'TBC'})
            </Text>
          </View>
        )}
        {app.status==='Accepted'&&(
          <View style={{flexDirection:'row',gap:6,backgroundColor:'#ECFDF5',borderRadius:8,padding:8,marginTop:6}}>
            <Ionicons name="checkmark-circle" size={14} color="#10B981"/>
            <Text style={{fontSize:11,color:'#065F46',fontWeight:'600'}}>🎉 Congratulations! You've been accepted!</Text>
          </View>
        )}
        {app.feedback&&(
          <View style={{flexDirection:'row',gap:6,backgroundColor:'#F8FAFC',borderRadius:8,padding:8,marginTop:6}}>
            <Ionicons name="chatbubble-ellipses-outline" size={13} color="#64748B"/>
            <Text style={{flex:1,fontSize:11,color:'#64748B',lineHeight:16}} numberOfLines={2}>{app.feedback}</Text>
          </View>
        )}

        <View style={{flexDirection:'row',gap:8,marginTop:10,borderTopWidth:1,borderTopColor:'#F1F5F9',paddingTop:8}}>
          <TouchableOpacity style={[st.detailBtn,{flex:1,justifyContent:'center'}]}
            onPress={()=>{setSelectedMyApp(app);setShowAppDetail(true);}}>
            <Text style={st.detailBtnT}>View Details</Text>
          </TouchableOpacity>
          {!['Rejected','Withdrawn','Accepted'].includes(app.status)&&(
            <TouchableOpacity style={[st.detailBtn,{flex:1,justifyContent:'center',backgroundColor:'#FEF2F2',borderColor:'#FCA5A5'}]}
              onPress={()=>withdrawApp(app)}>
              <Text style={[st.detailBtnT,{color:'#EF4444'}]}>Withdraw</Text>
            </TouchableOpacity>
          )}
        </View>
      </TouchableOpacity>
    );
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // MODALS
  // ═══════════════════════════════════════════════════════════════════════════
  const renderSortModal = () => (
    <Modal visible={showSortModal} transparent animationType="fade" onRequestClose={()=>setShowSortModal(false)}>
      <TouchableOpacity style={st.overlay} activeOpacity={1} onPress={()=>setShowSortModal(false)}>
        <View style={st.sortCard}>
          <Text style={st.sortCardTitle}>Sort By</Text>
          {SORT_OPTIONS.map(opt=>(
            <TouchableOpacity key={opt} style={[st.sortOpt,selectedSort===opt&&{backgroundColor:'#EFF6FF',borderRadius:10,paddingHorizontal:8,marginHorizontal:-8}]}
              onPress={()=>{setSelectedSort(opt);setShowSortModal(false);}}>
              <Text style={[{fontSize:14,color:'#374151'},selectedSort===opt&&{color:'#0e4e96',fontWeight:'700'}]}>{opt}</Text>
              {selectedSort===opt&&<Ionicons name="checkmark" size={18} color="#0e4e96"/>}
            </TouchableOpacity>
          ))}
        </View>
      </TouchableOpacity>
    </Modal>
  );

  const renderCompareModal = () => {
    if (compareList.length<2) return null;
    const rows=[{l:'Pay',fn:p=>p.compensation},{l:'Duration',fn:p=>p.duration},{l:'Location',fn:p=>p.location},{l:'Match',fn:p=>`${p.matchScore||'-'}%`},{l:'Rating',fn:p=>`${p.rating}⭐`},{l:'Deadline',fn:p=>fmtDate(p.deadline)}];
    return (
      <Modal visible={showCompare} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowCompare(false)}>
        <SafeAreaView style={{flex:1,backgroundColor:'#FFF'}}>
          <View style={st.mHdr}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setShowCompare(false)}><Ionicons name="close" size={22} color="#64748B"/></TouchableOpacity>
            <Text style={st.mTitle}>Compare Internships</Text>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setCompareList([])}><Ionicons name="trash-outline" size={20} color="#EF4444"/></TouchableOpacity>
          </View>
          <ScrollView style={{flex:1,padding:16}}>
            <View style={{flexDirection:'row',paddingBottom:12,borderBottomWidth:1,borderBottomColor:'#F1F5F9'}}>
              <View style={{width:80}}/>
              {compareList.map(p=>(
                <View key={p.id} style={{flex:1,alignItems:'center',paddingHorizontal:4}}>
                  <Image source={{uri:p.logo}} style={{width:34,height:34,borderRadius:8,marginBottom:4}}/>
                  <Text style={{fontSize:11,fontWeight:'700',color:'#1F2937',textAlign:'center',lineHeight:14}} numberOfLines={2}>{p.title}</Text>
                  <Text style={{fontSize:10,color:'#64748B',marginTop:1,textAlign:'center'}}>{p.company}</Text>
                </View>
              ))}
            </View>
            {rows.map(row=>(
              <View key={row.l} style={{flexDirection:'row',paddingVertical:10,borderBottomWidth:1,borderBottomColor:'#F8FAFC',alignItems:'center'}}>
                <Text style={{width:80,fontSize:12,color:'#64748B',fontWeight:'600'}}>{row.l}</Text>
                {compareList.map(p=><Text key={p.id} style={{flex:1,fontSize:13,fontWeight:'600',color:'#1F2937',textAlign:'center'}}>{row.fn(p)}</Text>)}
              </View>
            ))}
            <View style={{flexDirection:'row',gap:8,marginTop:16}}>
              <View style={{width:80}}/>
              {compareList.map(p=>(
                <TouchableOpacity key={p.id} style={[st.applyBtn,{flex:1,justifyContent:'center'}]} onPress={()=>{setShowCompare(false);openApply(p);}}>
                  <Text style={st.applyBtnT}>{appliedIds.has(p.id)?'Applied':'Apply'}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </ScrollView>
        </SafeAreaView>
      </Modal>
    );
  };

  const renderApplyModal = () => {
    const item=applyTarget; if(!item) return null;
    return (
      <Modal visible={showApplyModal} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowApplyModal(false)}>
        <KeyboardAvoidingView style={{flex:1,backgroundColor:'#FFF'}} behavior={Platform.OS==='ios'?'padding':'height'}>
          <View style={st.mHdr}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setShowApplyModal(false)}><Ionicons name="close" size={22} color="#64748B"/></TouchableOpacity>
            <Text style={st.mTitle} numberOfLines={1}>Apply — {item.company}</Text>
            <TouchableOpacity style={[st.applyBtn,applying&&{opacity:0.6}]} onPress={submitApplication} disabled={applying}>
              {applying?<ActivityIndicator size={13} color="#FFF"/>:<Text style={st.applyBtnT}>Submit</Text>}
            </TouchableOpacity>
          </View>
          <ScrollView style={{flex:1,padding:16}} keyboardShouldPersistTaps="handled">
            {/* Program summary */}
            <View style={{flexDirection:'row',backgroundColor:'#EFF6FF',borderRadius:12,padding:12,marginBottom:16,gap:10,alignItems:'center'}}>
              <Image source={{uri:item.logo}} style={{width:42,height:42,borderRadius:10}}/>
              <View style={{flex:1}}>
                <Text style={{fontSize:14,fontWeight:'700',color:'#0F172A'}}>{item.title}</Text>
                <Text style={{fontSize:12,color:'#3B82F6',marginTop:1}}>{item.company} · {item.compensation} · {item.duration}</Text>
                <Text style={{fontSize:11,color:'#94A3B8',marginTop:1}}>Deadline: {fmtDate(item.deadline)}</Text>
              </View>
            </View>
            {studentProfile.name&&(
              <View style={{backgroundColor:'#F0FDF4',borderRadius:10,padding:10,marginBottom:14,flexDirection:'row',gap:8,alignItems:'center'}}>
                <Ionicons name="checkmark-circle" size={15} color="#10B981"/>
                <Text style={{flex:1,fontSize:12,color:'#065F46'}}>Applying as <Text style={{fontWeight:'700'}}>{studentProfile.name}</Text>{studentProfile.university?` · ${studentProfile.university}`:''} — profile auto-attached.</Text>
              </View>
            )}
            {[
              {label:'Cover Letter *',          key:'coverLetter',       multi:true,  ph:'Write a compelling cover letter highlighting your passion and skills…'},
              {label:'Why are you interested? *',key:'whyInterested',    multi:true,  ph:'Explain your motivation for this specific role and company…'},
              {label:'Relevant Experience',      key:'relevantExperience',multi:true,  ph:'Projects, coursework, previous internships, research…'},
              {label:'Availability *',            key:'availability',    multi:false, ph:'e.g. Available from July 2025, 12 weeks'},
              {label:'Additional Information',    key:'additionalInfo',  multi:true,  ph:'Anything else you\'d like us to know?'},
            ].map(f=>(
              <View key={f.key} style={{marginBottom:14}}>
                <Text style={{fontSize:13,fontWeight:'600',color:'#374151',marginBottom:5}}>{f.label}</Text>
                <TextInput
                  style={{borderWidth:1,borderColor:'#E5E7EB',borderRadius:10,paddingHorizontal:12,paddingVertical:11,fontSize:14,color:'#0F172A',backgroundColor:'#FAFAFA',...(f.multi?{minHeight:88,textAlignVertical:'top'}:{})}}
                  value={appForm[f.key]} multiline={f.multi} numberOfLines={f.multi?4:1}
                  onChangeText={v=>setAppForm(p=>({...p,[f.key]:v}))}
                  placeholder={f.ph} placeholderTextColor="#9CA3AF"/>
              </View>
            ))}
            <View style={{height:24}}/>
          </ScrollView>
        </KeyboardAvoidingView>
      </Modal>
    );
  };

  const renderAppDetailModal = () => {
    const app=selectedMyApp; if(!app) return null;
    const sc=scColor(app.status);
    return (
      <Modal visible={showAppDetail} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowAppDetail(false)}>
        <SafeAreaView style={{flex:1,backgroundColor:'#FFF'}}>
          <View style={st.mHdr}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setShowAppDetail(false)}><Ionicons name="close" size={22} color="#64748B"/></TouchableOpacity>
            <Text style={st.mTitle} numberOfLines={1}>Application Details</Text>
            <View style={{width:36}}/>
          </View>
          <ScrollView style={{flex:1,padding:16}} showsVerticalScrollIndicator={false}>
            {/* Status banner */}
            <View style={{backgroundColor:sc+'18',borderRadius:14,padding:14,marginBottom:16,flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
              <View>
                <Text style={{fontSize:17,fontWeight:'800',color:sc}}>{app.status}</Text>
                <Text style={{fontSize:12,color:'#64748B',marginTop:2}}>{app.progress||10}% complete</Text>
              </View>
              <View style={{height:44,width:44,borderRadius:22,backgroundColor:sc+'22',justifyContent:'center',alignItems:'center'}}>
                <Ionicons name={app.status==='Accepted'?'checkmark-circle':app.status==='Rejected'?'close-circle':'time-outline'} size={24} color={sc}/>
              </View>
            </View>

            <Text style={{fontSize:18,fontWeight:'700',color:'#0F172A',marginBottom:4}}>{app.programTitle}</Text>
            <Text style={{fontSize:14,color:'#64748B',marginBottom:16}}>{app.company}</Text>

            {/* Timeline */}
            <Text style={{fontSize:14,fontWeight:'700',color:'#0F172A',marginBottom:12}}>Application Timeline</Text>
            {[
              {icon:'send-outline',color:'#667eea',label:'Submitted',date:app.appliedDate,show:true},
              {icon:'eye-outline',color:'#F59E0B',label:'Under Review',date:app.reviewedAt,show:!!app.reviewedAt},
              {icon:'calendar-outline',color:'#3B82F6',label:`Interview (${app.interviewType||'TBC'})`,date:app.interviewDate,show:!!app.interviewDate},
              {icon:'checkmark-circle-outline',color:'#10B981',label:'Accepted',date:app.acceptedAt,show:!!app.acceptedAt},
              {icon:'close-circle-outline',color:'#EF4444',label:'Rejected',date:app.rejectedAt,show:!!app.rejectedAt},
            ].filter(e=>e.show).map((ev,i)=>(
              <View key={i} style={{flexDirection:'row',alignItems:'flex-start',marginBottom:12}}>
                <View style={{width:28,height:28,borderRadius:14,backgroundColor:ev.color,justifyContent:'center',alignItems:'center'}}>
                  <Ionicons name={ev.icon} size={12} color="#FFF"/>
                </View>
                <View style={{marginLeft:12,flex:1}}>
                  <Text style={{fontSize:13,fontWeight:'600',color:'#374151'}}>{ev.label}</Text>
                  <Text style={{fontSize:11,color:'#94A3B8',marginTop:1}}>{fmtDate(ev.date)}</Text>
                </View>
              </View>
            ))}

            {/* Progress bar */}
            <View style={{marginBottom:16}}>
              <View style={{height:10,backgroundColor:'#E5E7EB',borderRadius:5,overflow:'hidden',marginBottom:6}}>
                <View style={{height:10,borderRadius:5,backgroundColor:sc,width:`${app.progress||10}%`}}/>
              </View>
              <Text style={{fontSize:12,color:'#64748B'}}>Next: {app.nextStep||'Initial Review'}</Text>
            </View>

            {/* Interview details */}
            {app.interviewDate&&(
              <View style={{backgroundColor:'#EFF6FF',borderRadius:12,padding:14,marginBottom:14,borderWidth:1,borderColor:'#BFDBFE'}}>
                <Text style={{fontSize:14,fontWeight:'700',color:'#1D4ED8',marginBottom:8}}>📅 Interview Details</Text>
                {[['Date',fmtDate(app.interviewDate)],['Time',app.interviewTime],['Type',app.interviewType],['Link',app.interviewLink],['Location',app.interviewLocation],['Duration',app.interviewDuration?app.interviewDuration+' min':''],['Interviewer',app.interviewerName]].filter(([,v])=>v).map(([k,v])=>(
                  <View key={k} style={{flexDirection:'row',gap:8,marginBottom:4}}>
                    <Text style={{fontSize:12,color:'#3B82F6',width:80}}>{k}</Text>
                    <Text style={{flex:1,fontSize:12,color:'#1D4ED8',fontWeight:'500'}}>{v}</Text>
                  </View>
                ))}
                {app.interviewLink&&(
                  <TouchableOpacity style={{marginTop:8,backgroundColor:'#3B82F6',borderRadius:8,padding:10,alignItems:'center'}} onPress={()=>Linking.openURL(app.interviewLink).catch(()=>{})}>
                    <Text style={{color:'#FFF',fontWeight:'700',fontSize:13}}>Join Interview</Text>
                  </TouchableOpacity>
                )}
              </View>
            )}

            {/* Recruiter feedback */}
            {app.feedback&&(
              <View style={{backgroundColor:'#F8FAFC',borderRadius:12,padding:14,marginBottom:14,borderWidth:1,borderColor:'#E5E7EB'}}>
                <Text style={{fontSize:13,fontWeight:'700',color:'#374151',marginBottom:6}}>Recruiter Feedback</Text>
                <Text style={{fontSize:13,color:'#64748B',lineHeight:19}}>{app.feedback}</Text>
              </View>
            )}
            {app.rejectionReason&&(
              <View style={{backgroundColor:'#FEF2F2',borderRadius:12,padding:14,marginBottom:14,borderWidth:1,borderColor:'#FECACA'}}>
                <Text style={{fontSize:13,fontWeight:'700',color:'#DC2626',marginBottom:6}}>Rejection Reason</Text>
                <Text style={{fontSize:13,color:'#7F1D1D',lineHeight:19}}>{app.rejectionReason}</Text>
              </View>
            )}

            {/* Application responses */}
            {[['Cover Letter',app.coverLetter],['Why Interested',app.whyInterested],['Relevant Experience',app.relevantExperience],['Availability',app.availability]].filter(([,v])=>v).map(([k,v])=>(
              <View key={k} style={{marginBottom:14}}>
                <Text style={{fontSize:13,fontWeight:'700',color:'#374151',marginBottom:6}}>{k}</Text>
                <View style={{backgroundColor:'#F8FAFC',borderRadius:10,padding:12,borderLeftWidth:3,borderLeftColor:'#0e4e96'}}>
                  <Text style={{fontSize:13,color:'#374151',lineHeight:19}}>{v}</Text>
                </View>
              </View>
            ))}

            {/* Actions */}
            {!['Rejected','Withdrawn','Accepted'].includes(app.status)&&(
              <TouchableOpacity style={{marginTop:4,backgroundColor:'#FEF2F2',borderRadius:12,paddingVertical:14,alignItems:'center',borderWidth:1,borderColor:'#FECACA'}} onPress={()=>withdrawApp(app)}>
                <Text style={{fontSize:14,fontWeight:'700',color:'#EF4444'}}>Withdraw Application</Text>
              </TouchableOpacity>
            )}
            <View style={{height:20}}/>
          </ScrollView>
        </SafeAreaView>
      </Modal>
    );
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // MAIN RENDER
  // ═══════════════════════════════════════════════════════════════════════════
  const appStats = [
    {l:'Submitted', v:myApplications.filter(a=>a.status==='Submitted').length,           c:'#8B5CF6'},
    {l:'Reviewing',  v:myApplications.filter(a=>a.status==='Under Review').length,         c:'#F59E0B'},
    {l:'Interview',  v:myApplications.filter(a=>a.status==='Interview Scheduled').length,  c:'#3B82F6'},
    {l:'Accepted',   v:myApplications.filter(a=>a.status==='Accepted').length,             c:'#10B981'},
    {l:'Rejected',   v:myApplications.filter(a=>a.status==='Rejected').length,             c:'#EF4444'},
  ];

  return (
    <SafeAreaView style={st.root}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96"/>

      {/* Header */}
      <LinearGradient colors={['#0e4e96','#1e7be2']} style={st.header}>
        <TouchableOpacity style={st.hdrBtn} onPress={()=>navigation.goBack()}>
          <Ionicons name="arrow-back" size={22} color="#FFF"/>
        </TouchableOpacity>
        <View style={{flex:1,alignItems:'center'}}>
          <Text style={st.hdrTitle}>Internship Applications</Text>
          <Text style={st.hdrSub}>{myApplications.length} applied · {filteredInternships.length} available</Text>
        </View>
        {activeMainTab==='browse'&&(
          <TouchableOpacity style={st.hdrBtn} onPress={()=>setViewMode(v=>v==='list'?'grid':'list')}>
            <Ionicons name={viewMode==='list'?'grid-outline':'list-outline'} size={20} color="#FFF"/>
          </TouchableOpacity>
        )}
        {activeMainTab==='myApps'&&(
          <View style={[st.hdrBtn,{backgroundColor:'rgba(255,255,255,0.25)'}]}>
            <Text style={{color:'#FFF',fontSize:13,fontWeight:'700'}}>{myApplications.length}</Text>
          </View>
        )}
      </LinearGradient>

      {/* Main tabs */}
      <View style={st.mainTabRow}>
        {[{k:'browse',l:'Browse',i:'search-outline'},{k:'myApps',l:'My Applications',i:'document-text-outline',badge:myApplications.filter(a=>['Submitted','Shortlisted','Interview Scheduled'].includes(a.status)).length}].map(t=>(
          <TouchableOpacity key={t.k} style={[st.mainTab,activeMainTab===t.k&&st.mainTabA]} onPress={()=>setActiveMainTab(t.k)}>
            <View style={{position:'relative'}}>
              <Ionicons name={t.i} size={16} color={activeMainTab===t.k?'#0e4e96':'#64748B'}/>
              {t.badge>0&&<View style={{position:'absolute',top:-4,right:-6,width:10,height:10,borderRadius:5,backgroundColor:'#EF4444'}}/>}
            </View>
            <Text style={[st.mainTabT,activeMainTab===t.k&&{color:'#0e4e96',fontWeight:'700'}]}>{t.l}</Text>
          </TouchableOpacity>
        ))}
      </View>

      {activeMainTab==='browse' ? (
        <Animated.View style={{flex:1,opacity:fadeAnim}}>
          {/* Stats bar */}
          <View style={st.statsBar}>
            {[{l:'Total',v:stats.total,c:'#0e4e96'},{l:'Saved',v:stats.saved,c:'#667eea'},{l:'Applied',v:stats.applied,c:'#10B981'},{l:'Urgent',v:stats.urgent,c:'#EF4444'}].map((s,i)=>(
              <View key={i} style={st.statCard}><Text style={[st.statNum,{color:s.c}]}>{s.v}</Text><Text style={st.statLbl}>{s.l}</Text></View>
            ))}
          </View>

          {/* Search + sort */}
          <View style={st.searchWrap}>
            <View style={st.searchBox}>
              <Ionicons name="search-outline" size={18} color="#94A3B8"/>
              <TextInput style={st.searchIn} placeholder="Search roles, companies…" value={searchQuery} onChangeText={setSearchQuery} placeholderTextColor="#94A3B8"/>
              {searchQuery?<TouchableOpacity onPress={()=>setSearchQuery('')}><Ionicons name="close-circle" size={18} color="#94A3B8"/></TouchableOpacity>:null}
            </View>
            <TouchableOpacity style={st.sortBtn} onPress={()=>setShowSortModal(true)}>
              <Ionicons name="swap-vertical-outline" size={18} color="#0e4e96"/>
            </TouchableOpacity>
          </View>

          {/* Filter chips */}
          <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{paddingHorizontal:14,gap:8,paddingVertical:10}} style={{backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'}}>
            {FILTER_OPTIONS.map(f=>(
              <TouchableOpacity key={f} style={[st.chip,selectedFilter===f&&{backgroundColor:'#0e4e96',borderColor:'#0e4e96'}]} onPress={()=>setSelectedFilter(f)}>
                <Text style={[st.chipT,selectedFilter===f&&{color:'#FFF'}]}>{f}</Text>
                {f==='Applied'&&appliedIds.size>0&&<View style={{width:16,height:16,borderRadius:8,backgroundColor:selectedFilter==='Applied'?'rgba(255,255,255,0.3)':'#0e4e96',justifyContent:'center',alignItems:'center',marginLeft:4}}><Text style={{fontSize:9,fontWeight:'700',color:'#FFF'}}>{appliedIds.size}</Text></View>}
              </TouchableOpacity>
            ))}
          </ScrollView>

          {/* Compare bar */}
          {compareList.length>0&&(
            <TouchableOpacity style={st.cmpBar} onPress={()=>setShowCompare(true)}>
              <MaterialCommunityIcons name="compare" size={15} color="#FFF"/>
              <Text style={st.cmpBarT}>Compare {compareList.length} internship{compareList.length>1?'s':''}</Text>
              <TouchableOpacity onPress={()=>setCompareList([])} hitSlop={{top:8,bottom:8,left:8,right:8}}>
                <Ionicons name="close" size={15} color="#FFF"/>
              </TouchableOpacity>
            </TouchableOpacity>
          )}

          {isLoading ? (
            <View style={st.loadWrap}><ActivityIndicator size={36} color="#0e4e96"/><Text style={st.loadT}>Loading opportunities…</Text></View>
          ) : (
            <FlatList
              data={filteredInternships}
              keyExtractor={i=>i.id}
              numColumns={viewMode==='grid'?2:1}
              key={viewMode}
              renderItem={({item})=>viewMode==='grid'?renderGridCard(item):renderCard(item)}
              contentContainerStyle={{padding:viewMode==='grid'?8:0,paddingBottom:40}}
              showsVerticalScrollIndicator={false}
              refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} colors={['#0e4e96']}/>}
              ListEmptyComponent={()=>(
                <View style={st.empty}>
                  <Ionicons name="search-outline" size={56} color="#CBD5E1"/>
                  <Text style={st.emptyT}>No internships found</Text>
                  <Text style={st.emptyS}>Try adjusting your filters</Text>
                  <TouchableOpacity style={st.emptyBtn} onPress={()=>{setSearchQuery('');setSelectedFilter('All');}}>
                    <Text style={st.emptyBtnT}>Clear Filters</Text>
                  </TouchableOpacity>
                </View>
              )}
            />
          )}
        </Animated.View>
      ) : (
        /* MY APPLICATIONS TAB */
        <Animated.View style={{flex:1,opacity:fadeAnim}}>
          {/* Summary stats */}
          <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{paddingHorizontal:14,paddingVertical:10,gap:10}} style={{backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0',flexGrow:0}}>
            {appStats.map(s=>(
              <View key={s.l} style={{alignItems:'center',backgroundColor:s.c+'15',borderRadius:12,paddingHorizontal:16,paddingVertical:10,borderWidth:1,borderColor:s.c+'30'}}>
                <Text style={{fontSize:20,fontWeight:'900',color:s.c}}>{s.v}</Text>
                <Text style={{fontSize:10,color:s.c,fontWeight:'600',marginTop:1}}>{s.l}</Text>
              </View>
            ))}
          </ScrollView>

          {/* Status filter */}
          <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{paddingHorizontal:14,gap:8,paddingVertical:10}} style={{backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0',flexGrow:0}}>
            {['All',...Object.keys(STATUS_COLORS)].map(s=>(
              <TouchableOpacity key={s}
                style={[st.chip, appStatusFilter===s&&{backgroundColor:STATUS_COLORS[s]||'#0e4e96',borderColor:STATUS_COLORS[s]||'#0e4e96'}]}
                onPress={()=>setAppStatusFilter(s)}>
                <Text style={[st.chipT,appStatusFilter===s&&{color:'#FFF'}]}>{s}</Text>
              </TouchableOpacity>
            ))}
          </ScrollView>

          {myApplications.length===0 ? (
            <View style={st.empty}>
              <MaterialCommunityIcons name="file-document-outline" size={64} color="#CBD5E1"/>
              <Text style={st.emptyT}>No Applications Yet</Text>
              <Text style={st.emptyS}>Browse internships and apply to start tracking</Text>
              <TouchableOpacity style={st.emptyBtn} onPress={()=>setActiveMainTab('browse')}>
                <Text style={st.emptyBtnT}>Browse Internships</Text>
              </TouchableOpacity>
            </View>
          ) : (
            <FlatList
              data={filteredMyApps}
              keyExtractor={a=>a.id}
              renderItem={({item})=>renderMyAppCard(item)}
              contentContainerStyle={{padding:14,paddingBottom:40}}
              showsVerticalScrollIndicator={false}
              refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} colors={['#0e4e96']}/>}
              ListEmptyComponent={()=>(
                <View style={st.empty}>
                  <Ionicons name="filter-outline" size={48} color="#CBD5E1"/>
                  <Text style={st.emptyT}>No {appStatusFilter} applications</Text>
                </View>
              )}
            />
          )}
        </Animated.View>
      )}

      {renderSortModal()}
      {renderCompareModal()}
      {renderApplyModal()}
      {renderAppDetailModal()}
    </SafeAreaView>
  );
}

const st = StyleSheet.create({
  root:       {flex:1,backgroundColor:'#F8FAFC'},
  header:     {paddingHorizontal:14,paddingVertical:12,flexDirection:'row',alignItems:'center'},
  hdrBtn:     {width:36,height:36,borderRadius:10,backgroundColor:'rgba(255,255,255,0.18)',justifyContent:'center',alignItems:'center'},
  hdrTitle:   {fontSize:17,fontWeight:'700',color:'#FFF'},
  hdrSub:     {fontSize:11,color:'rgba(255,255,255,0.8)',marginTop:1},
  mainTabRow: {flexDirection:'row',backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'},
  mainTab:    {flex:1,flexDirection:'row',justifyContent:'center',alignItems:'center',gap:6,paddingVertical:13,borderBottomWidth:3,borderBottomColor:'transparent'},
  mainTabA:   {borderBottomColor:'#0e4e96'},
  mainTabT:   {fontSize:13,color:'#64748B',fontWeight:'500'},
  statsBar:   {flexDirection:'row',backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'},
  statCard:   {flex:1,alignItems:'center',paddingVertical:10},
  statNum:    {fontSize:18,fontWeight:'900'},
  statLbl:    {fontSize:10,color:'#94A3B8',fontWeight:'600',marginTop:1},
  searchWrap: {flexDirection:'row',paddingHorizontal:14,paddingVertical:10,gap:8,backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'},
  searchBox:  {flex:1,flexDirection:'row',alignItems:'center',backgroundColor:'#F1F5F9',borderRadius:12,paddingHorizontal:12,paddingVertical:10,gap:8},
  searchIn:   {flex:1,fontSize:14,color:'#0F172A'},
  sortBtn:    {width:44,height:44,borderRadius:12,backgroundColor:'#EFF6FF',justifyContent:'center',alignItems:'center',borderWidth:1,borderColor:'#BFDBFE'},
  chip:       {paddingHorizontal:14,paddingVertical:7,borderRadius:20,backgroundColor:'#F1F5F9',borderWidth:1,borderColor:'#E2E8F0',flexDirection:'row',alignItems:'center'},
  chipT:      {fontSize:12,color:'#64748B',fontWeight:'600'},
  cmpBar:     {flexDirection:'row',alignItems:'center',gap:8,backgroundColor:'#0e4e96',marginHorizontal:14,marginTop:8,borderRadius:10,padding:10},
  cmpBarT:    {flex:1,color:'#FFF',fontWeight:'600',fontSize:13},
  loadWrap:   {flex:1,justifyContent:'center',alignItems:'center',padding:24},
  loadT:      {marginTop:12,fontSize:14,color:'#64748B'},
  iconBtn:    {width:30,height:30,borderRadius:8,backgroundColor:'#F8FAFC',justifyContent:'center',alignItems:'center',borderWidth:1,borderColor:'#E2E8F0'},
  card:       {backgroundColor:'#FFF',marginHorizontal:14,marginTop:12,borderRadius:16,padding:14,elevation:2,shadowColor:'#000',shadowOpacity:0.06,shadowRadius:8},
  hotBadge:   {position:'absolute',top:10,right:12,backgroundColor:'#FEF3C7',borderRadius:8,paddingHorizontal:8,paddingVertical:3,zIndex:1},
  hotBadgeT:  {fontSize:10,fontWeight:'700',color:'#D97706'},
  cardTop:    {flexDirection:'row',marginBottom:10,gap:10},
  logo:       {width:46,height:46,borderRadius:10,backgroundColor:'#F1F5F9'},
  cardTitle:  {fontSize:15,fontWeight:'700',color:'#0F172A'},
  cardCo:     {fontSize:13,color:'#64748B',marginTop:1},
  metaRow:    {flexDirection:'row',flexWrap:'wrap',gap:8,marginTop:5},
  metaItem:   {flexDirection:'row',alignItems:'center',gap:3},
  metaT:      {fontSize:11,color:'#64748B'},
  cardDesc:   {fontSize:13,color:'#64748B',lineHeight:18,marginBottom:10},
  tagsRow:    {flexDirection:'row',flexWrap:'wrap',gap:6,marginBottom:10},
  tag:        {borderRadius:12,borderWidth:1,paddingHorizontal:8,paddingVertical:3},
  tagT:       {fontSize:11,fontWeight:'600'},
  cardFoot:   {flexDirection:'row',justifyContent:'space-between',alignItems:'center'},
  ratingT:    {fontSize:12,color:'#64748B',fontWeight:'600'},
  cmpBtn:     {width:26,height:26,borderRadius:6,backgroundColor:'#EEF2FF',justifyContent:'center',alignItems:'center',marginLeft:6,borderWidth:1,borderColor:'#C4B5FD'},
  detailBtn:  {paddingHorizontal:12,paddingVertical:7,borderRadius:10,backgroundColor:'#F1F5F9',borderWidth:1,borderColor:'#E2E8F0'},
  detailBtnT: {fontSize:12,fontWeight:'600',color:'#374151'},
  applyBtn:   {backgroundColor:'#0e4e96',borderRadius:10,paddingHorizontal:16,paddingVertical:8,justifyContent:'center',alignItems:'center'},
  applyBtnT:  {fontSize:13,fontWeight:'700',color:'#FFF'},
  gridCard:   {flex:1,backgroundColor:'#FFF',borderRadius:14,margin:5,padding:12,elevation:1,borderWidth:1,borderColor:'#E2E8F0'},
  gridLogo:   {width:40,height:40,borderRadius:8,marginBottom:8},
  gridTitle:  {fontSize:13,fontWeight:'700',color:'#0F172A',lineHeight:17},
  gridCo:     {fontSize:11,color:'#64748B',marginTop:2},
  appCard:    {backgroundColor:'#FFF',borderRadius:14,padding:14,marginBottom:12,borderLeftWidth:4,elevation:1,shadowColor:'#000',shadowOpacity:0.05,shadowRadius:6},
  appTitle:   {fontSize:15,fontWeight:'700',color:'#0F172A'},
  appCo:      {fontSize:13,color:'#64748B',marginTop:2},
  appDate:    {fontSize:11,color:'#94A3B8',marginTop:2},
  statusBadge:{borderRadius:10,paddingHorizontal:10,paddingVertical:5,alignSelf:'flex-start',marginLeft:8},
  statusBadgeT:{fontSize:11,fontWeight:'700'},
  empty:      {alignItems:'center',paddingVertical:60,paddingHorizontal:24},
  emptyT:     {fontSize:16,fontWeight:'700',color:'#374151',marginTop:12},
  emptyS:     {fontSize:13,color:'#94A3B8',textAlign:'center',marginTop:6},
  emptyBtn:   {marginTop:16,backgroundColor:'#0e4e96',borderRadius:10,paddingHorizontal:20,paddingVertical:10},
  emptyBtnT:  {color:'#FFF',fontWeight:'700',fontSize:14},
  overlay:    {flex:1,backgroundColor:'rgba(0,0,0,0.4)',justifyContent:'flex-end',padding:14},
  sortCard:   {backgroundColor:'#FFF',borderRadius:18,padding:16},
  sortCardTitle:{fontSize:16,fontWeight:'800',color:'#0F172A',marginBottom:12},
  sortOpt:    {flexDirection:'row',justifyContent:'space-between',alignItems:'center',paddingVertical:13,borderBottomWidth:1,borderBottomColor:'#F1F5F9'},
  mHdr:       {flexDirection:'row',alignItems:'center',padding:16,borderBottomWidth:1,borderBottomColor:'#E5E5EA',gap:8},
  mTitle:     {flex:1,textAlign:'center',fontSize:16,fontWeight:'700',color:'#0F172A'},
});
